export const COUNTRIES_FETCH_SUCCESS = "COUNTRIES_FETCH_SUCCESS";
export const COUNTRIES_RESET = "COUNTRIES_RESET";